import React, { useEffect } from 'react'
import { componentKey as ManageUserComponentKey, selectPayer, setSelectedGroupIDs, setSelectedMember, setShowUserInfoPopup } from '../../manageusers/ManageUserSlice'
import { useDispatch, useSelector } from 'react-redux';
import { HEADING } from '../../../../components/heading/constants/constants';
import Heading from '../../../../components/heading/Heading';
import Label from '../../../../components/label/Label';
import TextInput from '../../../../components/input/textinput/TextInput';
import { LABEL_WEIGHT } from '../../../../components/label/constants';
import SelectDropdown from '../../../../components/dropdown/selectdropdown/SelectDropdown';
import TabbedNavigationWithDefinedTitle from '../../../../components/tabbednavigation/TabbedNavigationWithDefinedTitle';
import RightsSection from '../rightssection/RightsSection';
import AssignPayers from '../assignpayers/AssignPayers';
import styles from './UserInfo.styles';
import { assignPayersToMemberUser, createMemberUser, getMemberRoles, getRolesPermissions, updateMemberUser } from '../../manageusers/ManageUserSaga';
import { BUTTON_TYPE } from '../../../../components/button/constants';
import Button from '../../../../components/button/Button';
import { useState } from 'react';
import General from '../../../../../libs/utility/General';
import { addNotifications } from '../../../toaster/ToasterPortalSlice';

function UserInfo({
	onCloseCb = () => {},
}) {
	const { selectedMember, memberRoles, memberData, selectedPayers } = useSelector((state) => state[ManageUserComponentKey]);
	const dispatch = useDispatch();
	const [isNameValid, setIsNameValid] = useState(true); 
	
	useEffect(() => {
		dispatch(getMemberRoles())
		if(Object.keys(selectedMember).length === 0) {
			dispatch(setSelectedMember({FirstName: "", Email: ""}))
			dispatch(getRolesPermissions({role: '3', selectedMember: {...selectedMember, Role: '3'}}))
		}
	}, [])
	const handleInputChange = (e) => {
		dispatch(setSelectedMember({ ...selectedMember, [e.target.name]: e.target.value }))
	}

	const handleDropDownChange = (name, selectedOption) => {
		const updatedMember = { ...selectedMember, Role: selectedOption.label }
		dispatch(setSelectedMember(updatedMember))
		dispatch(getRolesPermissions({role: selectedOption.value, selectedMember: updatedMember}))
	}

	const getUserRole = () => {
		let roleResult = memberRoles[0]
		let filterRole = memberRoles.find(memberRole => (memberRole.value === selectedMember.Role || memberRole.label === selectedMember.Role))
		if (filterRole) {
			roleResult = filterRole
		}
		return roleResult;
	}

	const tabListWithTitleObj = [
		{
			title: {
				titleText: "Rights Section",
			},
			tabBodyComponent: <RightsSection />,
		}, {
			title: {
				titleText: "Assign Payers(Optional)",
			},
			tabBodyComponent: selectedMember.UserId !== 0 ? <AssignPayers /> : <span>Please save the user before assigning payers</span>,
		}
	];

	const handleOnTabChange = (index) => {
	}
	const handleUserUpdate = () => {
		if(!isNameValid){
			dispatch(addNotifications({
				heading: "Invalid Name Entered",
				message: "Member Name should only consist any of A-Z,a-z, 0-9,-,.&' letters and maximum 40 character",
			}))
		}	
		else if(selectedMember.UserId && selectedMember.UserId !== 0){
			dispatch(updateMemberUser(selectedMember))
		}
		else {
			dispatch(createMemberUser(selectedMember))
		}
	}

	const handleUserCancel = () => {
		onCloseCb()
	}
	
	const handleValidateName = (e) => {
		setIsNameValid(General.validateName(e.target.value))
	}
	
	return (
		<div style={styles.mainContainer}>
			<Heading type={HEADING.H1}>{ (selectedMember?.UserId && selectedMember.UserId !== 0) ? "Edit User" : "Add New User"}</Heading>
			<div style={styles.userInfoRow}>
				<Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Member Name </Label>
				<TextInput
					onBlurCb={ handleValidateName }
					type={'text'}
					placeHolder={"Member Name"}
					name={'FirstName'}
					value={selectedMember.FirstName}
					onChangeCb={(e) => handleInputChange(e)}
				/>
				{ !isNameValid &&  <div style={{ color: 'red'}}>Member Name should only consist any of A-Z,a-z, 0-9,-,.&' letters and maximum 40 character</div>}
			</div>

			<div style={styles.userInfoRow}>
				<Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Email </Label>
				<TextInput
					type={'text'}
					placeHolder={"Member Email"}
					name={'Email'}
					value={selectedMember.Email}
					onChangeCb={(e) => handleInputChange(e)}
				/>
			</div>
			<div style={styles.userInfoRow}>
				<Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Phone </Label>
				<TextInput
					type={'number'}
					placeHolder={"Member Phone"}
					name={'PhoneNumber'}
					value={selectedMember.PhoneNumber}
					onChangeCb={(e) => handleInputChange(e)}
				/>
			</div>
			<div style={styles.userInfoRow}>
				<Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>User Role </Label>
				<SelectDropdown
					name="Role"
					value={getUserRole()}
					prefixProps={{ text: "" }}
					onSelectCb={(name, selectedOption) => handleDropDownChange(name, selectedOption)}
					options={memberRoles}
				/>
			</div>

			<TabbedNavigationWithDefinedTitle tabListWithTitleObj={tabListWithTitleObj} onChangeTabCb={handleOnTabChange} />

			<div style={styles.buttonsRow}>
				<Button type={BUTTON_TYPE.PRIMARY} onClickCb={ handleUserUpdate }>Save User</Button>
				<Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={ handleUserCancel }>Cancel</Button>
			</div>
		</div>
	)
}

export default UserInfo